<template>
    <div class="campaign-list-page">
        <campaign-table ref="table" :url="indexUrl">
            <template v-slot:buttons>
                <el-tooltip
                    v-if="canCreate"
                    content="New"
                    effect="light"
                    placement="top-start"
                    :open-delay="300"
                >
                    <button class="btn btn-purple" @click="addCampaign">
                        <i class="far fa-file"></i>
                    </button>
                </el-tooltip>
                <el-tooltip
                    v-if="canIndexTemplate"
                    content="New From Template"
                    effect="light"
                    placement="top-start"
                    :open-delay="300"
                >
                    <button class="btn btn-purple" @click="addFromTemplate">
                        <i class="fas fa-copy"></i>
                    </button>
                </el-tooltip>
                <el-tooltip
                        v-if="canPreview"
                        content="Schedule messages sending"
                        effect="light"
                        placement="top-start"
                        :open-delay="300"
                >
                    <a :href="previewUrl" class="btn btn-purple">
                        <i class="fas fa-calendar-check"></i>
                    </a>
                </el-tooltip>
            </template>
        </campaign-table>
        <dialog-form-wrapper></dialog-form-wrapper>
        <dialog-campaign-templates-table
                :url="templateIndexUrl"
                @select="onTemplateSelect"
        ></dialog-campaign-templates-table>
        <dialog-view-wrapper></dialog-view-wrapper>
    </div>
</template>

<script>
  import CampaignTable from '../../components/campaign/table';
  import eventBus from '../../event-bus';
  import DialogFormWrapper from './dialog-form-wrapper';
  import DialogCampaignTemplatesTable from './dialog-campaign-templates-table';
  import {addQueryParams} from '../../libs/url';
  import DialogViewWrapper from './dialog-view-wrapper';

  export default {
    components: {
      CampaignTable,
      DialogFormWrapper,
      DialogCampaignTemplatesTable,
      DialogViewWrapper,
    },

    props: {
      indexUrl: null,
      createUrl: null,
      canCreate: {
        type: Boolean,
        default: false
      },
      canPreview: {
        type: Boolean,
        default: false
      },
      canIndexTemplate: {
        type: Boolean,
        default: false
      },
      previewUrl: null,
      templateIndexUrl: null,
    },

    methods: {
      /**
       * @return {undefined}
       */
      refresh() {
        this.$refs.table.refresh();
      },

      /**
       * @event show-add-campaign-dialog
       */
      addCampaign() {
        eventBus.$emit('show-add-campaign-dialog', this.createUrl);
      },

      /**
       * @event show-campaign-templates-dialog
       */
      addFromTemplate() {
        eventBus.$emit('show-campaign-templates-dialog', this.createUrl);
      },

      /**
       * @event show-add-campaign-dialog
       */
      onTemplateSelect(row) {
        const id = _.get(row, 'model.id', null);
        const params = id ? {template_id: id} : {};
        eventBus.$emit('show-add-campaign-dialog', addQueryParams(this.createUrl, params));
      },
    },

    created() {
      eventBus.$on('refresh-campaign-table', this.refresh);
    },

    beforeDestroy() {
      eventBus.$off('refresh-campaign-table', this.refresh);
    }
  }
</script>
